export default __webpack_public_path__ + "static/media/WAS0190.34I-36139_-21168_0.abd566ba.jpg";